/* "Build your interior": add the real products the customer picked (not one lump-sum line),
   so checkout gets the right mats, rears, headrests, seatbelts, charm and freshener.
   The 6/9/12% and free freshener are Shopify automatic discounts ("Build your interior: ..."). */
(() => {
  const $ = id => document.getElementById(id);
  const norm = s => (s || '').toLowerCase().replace(/[^a-z0-9]+/g, '');
  const SCOPE = { mat: '#v-mats', head: '#s-headrest', belt: '#s-seatbelt', charm: '#s-charm', fresh: '#s-fresh' };
  const REAR = { ryukoirear: 'dragon-x-koi-floor-mats', ryuxkoirear: 'dragon-x-koi-floor-mats', sharinganrear: 'sharigan-manga-panel-floor-mat', namiwantedposter: 'luffy-zoro-floor-mats', ichigohollowrear: 'ichigo-bankai-x-hollow-form-limited-edition-floor-mats', ps2dragonrear: 'retro-playstation-floor-mats', berserkrear: 'berserk-you-cannot-escape-floor-mat-set', onimasksrear: 'the-oni-masks-floor-mats', kaminoichimatsurear: 'kami-no-ichimatsu-series-red-checkered-floor-mat-set' };
  const PJ = {};
  const pj = h => PJ[h] || (PJ[h] = fetch('/products/' + encodeURIComponent(h) + '.js').then(r => r.ok ? r.json() : null).catch(() => null));
  const handleFor = (k, name) => {
    if (k === 'rear') return REAR[norm(name)] || null;
    const sel = SCOPE[k]; if (!sel) return null;
    for (const c of document.querySelectorAll(sel + ' [data-h]')) { const t = (c.querySelector('h3,b') || {}).textContent; if (norm(t) === norm(name)) return c.dataset.h; }
    return null;
  };
  const pickVariant = (p, k, z) => {
    const av = p.variants.filter(v => v.available), L = av.length ? av : p.variants;
    let re = null;
    if (k === 'mat') re = /driver|front|passenger/i;
    if (k === 'rear') re = /rear/i;
    if (k === 'head') re = z === 'pair' ? /pair/i : /single/i;
    const m = re && L.find(v => re.test(v.title) && !(k === 'mat' && /full|mixed|rear/i.test(v.title)));
    return m || L[0];
  };
  const num = t => parseFloat(String(t || '').replace(/[^0-9.]/g, '')) || 0;
  let busy = false;
  document.addEventListener('click', async e => {
    const b = e.target.closest('#bcta'); if (!b || b.disabled || !window.CARTX) return;
    e.preventDefault(); e.stopImmediatePropagation();
    if (busy) return; busy = true;
    try {
      const picks = [];
      document.querySelectorAll('#bsteps .bz-bstep').forEach(sec => {
        if (sec.hidden) return;
        const o = sec.querySelector('.bz-opt[aria-pressed="true"]:not(.bz-skip)'); if (!o) return;
        const zb = sec.querySelector('.bz-seg2 button[aria-pressed="true"]');
        const pz = num((sec.querySelector('.bz-pz') || {}).textContent);
        picks.push({ k: sec.dataset.k, name: o.querySelector('b').textContent.trim(), z: zb ? zb.dataset.z : null, price: /FREE/i.test((sec.querySelector('.bz-pz') || {}).textContent) ? 0 : pz });
      });
      const total = num(($('btotal') || {}).textContent);
      const lines = [];
      for (const p of picks) {
        const h = handleFor(p.k, p.name); const prod = h && await pj(h);
        if (!prod) { lines.push({ h: '', n: p.name, p: p.price, k: p.k }); continue; }
        const v = pickVariant(prod, p.k, p.z);
        const vt = v && v.title !== 'Default Title' ? ' · ' + v.title : '';
        lines.push({ h, n: prod.title.split('|')[0].trim() + vt, p: p.price, k: p.k });
      }
      const S = CARTX.S();
      lines.forEach(l => {
        CARTX.named(l.n, l.p, l.k === 'fresh', l.k === 'charm');
        const last = S.l.slice().reverse().find(x => x.n === l.n); if (last) { last.h = l.h; delete last.k; }
      });
      const paid = lines.reduce((a, l) => a + l.p, 0), save = Math.round((paid - total) * 100) / 100;
      if (save > 0.004) S.l.push({ h: '', n: 'Build your interior · bundle savings', p: -save, q: 1, a: 0 });
      if (window.cartAdd) cartAdd(total);
      const t = $('toast'); if (t) { t.textContent = 'Your interior was added to the cart'; t.classList.add('on'); clearTimeout(t._t); t._t = setTimeout(() => t.classList.remove('on'), 2200); }
    } finally { busy = false; }
  }, true);
})();
/* Swipe rows: scroll-snap was snapping past the row's left padding, cutting off the first tile. */
(() => {
  const st = document.createElement('style');
  st.textContent = '.bz-orow,.itiles{scroll-padding-inline:14px}.fgrow{scroll-padding-inline:16px}' +
    /* Spirit Garage 3D car box was wider than the phone screen (min-height forced it wide), pushing "Drag to spin" off screen */
    '.sgart.sg3{min-height:0!important;width:100%;max-width:100%}' +
    /* Vinyl wrap feature block was 8px wider than small phones */
    '.wrfeat>*{min-width:0}' +
    /* "Sort by / Best selling" bar had a -4px top margin, sliding it up over the subcategory chips */
    '.filters+.sortbar{margin-top:10px!important}';
  document.head.appendChild(st);
  const fix = () => document.querySelectorAll('.bz-orow,.itiles,.fgrow').forEach(r => { const pl = parseFloat(getComputedStyle(r).paddingLeft) || 0; if (r.scrollLeft > 0 && r.scrollLeft <= pl + 1) r.scrollLeft = 0; });
  fix(); addEventListener('hashchange', () => setTimeout(fix, 50)); setTimeout(fix, 1000);
})();
/* Build your interior, "Rear mats" step: show one small rear mat (square crop from each set's flat-lay photo),
   not the front mat. */
(() => {
  const F = 'https://cdn.shopify.com/s/files/1/0503/2345/6167/files/';
  const c = (f, l, t, w, h) => F + f + '?crop=region&crop_left=' + l + '&crop_top=' + t + '&crop_width=' + w + '&crop_height=' + h;
  window.INC_REAR = {
    'Ryu x Koi rear': c('DSC_0110.jpg', 1222, 1433, 1415, 1415),
    'Sharingan rear': c('DSC_0795.jpg', 933, 1518, 1179, 1179),
    'Nami Wanted Poster': c('DSC_0099_449f2f4d-28aa-43cc-9a0c-dd34fdfcf40f.jpg', 1132, 1339, 1509, 1509),
    'Ichigo Hollow rear': c('DSC_0818_4a6fa64c-c73a-467d-87f6-03599e94830b.jpg', 1087, 1291, 1557, 1557),
    'PS2 Dragon rear': c('DSC_0769_4b7779da-1e7b-4eef-a9c3-d1c978f3c793.jpg', 450, 1158, 1415, 1415),
    'Berserk rear': c('DSC_0546_947b2e74-1ee6-4109-b0e5-5eeefffc589c.jpg', 720, 1299, 1132, 1132),
    'Oni Masks rear': c('DSC_0743_720x_860c8d88-858e-4021-b58f-34c1af42a0ad.jpg', 180, 96, 396, 359),
    'Kami no Ichimatsu rear': c('DSC_0640.jpg', 662, 1386, 1462, 1462)
  };
  // set the tile photos and flag them so photo-hd.js leaves them alone (it would swap in the front mat)
  const fix = () => document.querySelectorAll('#bsteps .bz-bstep[data-k="rear"] .bz-opt img').forEach(img => {
    const b = img.closest('.bz-opt').querySelector('b'), u = b && window.INC_REAR[b.textContent.trim()];
    if (!u || img.dataset.rear === u) return;
    img.__hd = 1; img.__hdo = 1; img.__fx = 1;
    img.removeAttribute('srcset'); img.removeAttribute('sizes');
    img.src = u + '&width=480'; img.dataset.rear = u;
  });
  fix(); document.addEventListener('DOMContentLoaded', fix); addEventListener('hashchange', () => setTimeout(fix, 30));
  new MutationObserver(fix).observe(document.documentElement, { childList: true, subtree: true });
})();
/* Product pages (#p/handle): show every photo uploaded to the Shopify product (swipe, arrows on desktop, dots),
   not just the single main picture. */
(() => {
  const st0 = document.createElement('style');
  st0.textContent = '.gnav{position:absolute;top:50%;transform:translateY(-50%);z-index:3;width:40px;height:40px;border-radius:50%;border:0;background:rgba(0,0,0,.55);color:#fff;font-size:22px;line-height:40px;text-align:center;cursor:pointer;display:none;padding:0}' +
    '.gnav.p{left:10px}.gnav.n{right:10px}@media (hover:hover) and (min-width:760px){#v-pdp .galw.many .gnav{display:block}}#v-pdp .gdots i{cursor:pointer}';
  document.head.appendChild(st0);
  const abs = u => (u.startsWith('//') ? 'https:' + u : u);
  const bn = u => String(u || '').split('/').pop().split('?')[0];
  const PC = {};
  const prod = h => PC[h] || (PC[h] = fetch('/products/' + encodeURIComponent(h) + '.js').then(r => (r.ok ? r.json() : null)).catch(() => null));
  const parts = () => {
    const v = document.getElementById('v-pdp'), g = v && v.querySelector('.gal');
    return g ? { g, st: g.querySelector('.gstrip'), dots: g.querySelector('.gdots'), cnt: g.querySelector('.gcount'), w: g.querySelector('.galw') } : {};
  };
  function mark() {
    const { st, dots, cnt } = parts(); if (!st) return;
    const n = st.children.length, k = Math.min(n - 1, Math.round(st.scrollLeft / (st.clientWidth || 1)));
    if (dots) [...dots.children].forEach((d, j) => d.classList.toggle('on', j === k));
    if (cnt) { const t = (k + 1) + ' / ' + n; if (cnt.textContent !== t) cnt.textContent = t; }
  }
  async function fill() {
    const m = location.hash.match(/^#p\/([^/?#]+)/); if (!m) return;
    const h = decodeURIComponent(m[1]);
    let { g, st } = parts(); if (!st) return;
    const p = await prod(h); if (!p || !location.hash.startsWith('#p/' + m[1])) return;
    ({ g, st } = parts()); if (!st) return;
    const main = document.getElementById('pdimg');
    const mb = main ? (main.dataset.hd || bn(main.getAttribute('src'))) : '';
    const key = h + '|' + mb;
    if (st.dataset.key !== key) {
      st.querySelectorAll('.gpx').forEach(e => e.remove());
      const name = (p.title || '').split('|')[0].trim();
      (p.images || []).map(abs).filter(u => bn(u) !== mb).forEach((u, i) => {
        const d = document.createElement('div'); d.className = 'pdimg gpx';
        const im = document.createElement('img');
        im.src = u + (u.includes('?') ? '&' : '?') + 'width=1200'; im.alt = name + ' photo ' + (i + 2); im.loading = 'lazy'; im.decoding = 'async';
        d.appendChild(im); st.appendChild(d);
      });
      st.dataset.key = key; st.scrollLeft = 0;
    }
    const { dots, cnt, w } = parts(), n = st.children.length;
    if (dots) { if (dots.children.length !== n) dots.innerHTML = '<i></i>'.repeat(n); if (dots.hidden !== n < 2) dots.hidden = n < 2; }
    if (cnt && cnt.hidden !== n < 2) cnt.hidden = n < 2;
    if (w) {
      w.classList.toggle('many', n > 1);
      if (!w.querySelector('.gnav')) {
        w.insertAdjacentHTML('beforeend', '<button type="button" class="gnav p" aria-label="Previous photo">‹</button><button type="button" class="gnav n" aria-label="Next photo">›</button>');
        w.addEventListener('click', e => { const b = e.target.closest('.gnav'); if (!b) return; const s = parts().st; s.scrollBy({ left: (b.classList.contains('n') ? 1 : -1) * s.clientWidth, behavior: 'smooth' }); });
      }
    }
    if (!st.__gx) {
      st.__gx = 1;
      st.addEventListener('scroll', () => { clearTimeout(st.__t); st.__t = setTimeout(mark, 50); }, { passive: true });
      g.addEventListener('click', e => { const i = e.target.closest('.gdots i'); if (!i) return; const s = parts().st; s.scrollTo({ left: [...i.parentNode.children].indexOf(i) * s.clientWidth, behavior: 'smooth' }); });
    }
    mark();
  }
  let t;
  const later = () => { clearTimeout(t); t = setTimeout(fill, 150); };
  const v = document.getElementById('v-pdp');
  if (v) new MutationObserver(later).observe(v, { childList: true, subtree: true, attributes: true, attributeFilter: ['src'] });
  addEventListener('hashchange', later); later(); setTimeout(fill, 1500);
})();
